import React, {type FC} from 'react'
import {Button, Select} from 'uikit'
import {CupIcon} from 'uikit/Icons'
import {useAppSelector} from 'store'
import {getTranslates} from 'store/translates/selectors'
import type {LangType} from 'src/lib/translates/types'
import {GameProgress} from 'src/common/components/GameProgress'
import {MenuProps} from '../index'
import styles from './DesktopMenu.scss'


export const DesktopMenu: FC<MenuProps> = props => {
  const {
    messageStartGame,
    currentLang,
    languages,
    donateMessage,
    handleStartGame,
    handleChangeLanguage,
    handleDonate,
    handleOpenTop,
  } = props
  const translates = useAppSelector(getTranslates)

  return (
    <div className={styles.wrap}>
      <Button onClick={handleStartGame}>
        {messageStartGame}
      </Button>
      <Select<LangType>
        onChange={handleChangeLanguage}
        options={languages}
        value={currentLang}
        className={styles.selectWrapper}
      />
      {handleOpenTop && (
        <Button className={styles.topCup} onClick={handleOpenTop}>
          <CupIcon />{translates.TOP}
        </Button>
      )}
      <GameProgress />
      {handleDonate && <Button onClick={handleDonate}>{donateMessage}</Button>}
    </div>
  )
}
